import(/* webpackMode: "eager" */ "/codebuild/output/src4088909342/src/src/app/global-error.tsx");
